module.exports = __webpack_public_path__ + "media/favicon/android-chrome-192x192-8348a9fe1d30bac124cfbab7e4c1733c.png";